<template>
  <div :class="className">
    <a
      v-perm="access"
      href="javascript:void(0);"
      :loading="loading"
      type="link"
      danger
      @click="showDialog"
      style="color: #ff4d4f"
    >
      关闭项目
    </a>
    <a-modal
      :confirmLoading="loading"
      v-model:visible="visible"
      title="关闭项目 "
      :centered="true"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form layout="vertical" ref="formRef" :model="formModel">
        <a-form-item label="项目关闭原因分类" name="closeReasonType">
          <a-input v-model:value="formModel.closeReasonType" disabled placeholder="项目关闭原因分类" />
        </a-form-item>
        <a-form-item label="项目关闭原因" name="projectCloseReason">
          <a-textarea
            show-count
            v-model:value="formModel.projectCloseReason"
            placeholder="请输入说明，最多200字"
            :auto-size="{ minRows: 3 }"
            :maxlength="200"
            allowClear
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script lang="ts">
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { getCurrentTenantId } from "@/utils";
import { message } from "ant-design-vue";
import { defineComponent, reactive, ref, toRefs } from "vue";
import { CloseProjectService } from "./close-project.service";

export default defineComponent({
  name: "CloseProjectBtn",
  isGlobal: true,
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizName: {
      type: String,
      required: true,
    },
    access: { type: String },
    loading: {
      type: Boolean,
    },
    className: {
      type: String,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const state = reactive({
      visible: false,
      formModel: {
        closeReasonType: '',
        projectCloseReason: "",
      },
      formRef: ref(),
    });

    const showDialog =async () => {
      state.formModel.closeReasonType =''
      let res = await getReason(props.bizId);
      if (res.respCode == "0000") {
        state.formModel.closeReasonType = res.data?.closeReasonType || "";
      }
      state.visible = true;
    };
    const cancel = () => {
      state.formRef.resetFields();
    };
    const { run: getReason } = CloseProjectService.useCloseProjectReasonApi();
    const { run: addClose } = CloseProjectService.useAddCloseApi();
    const handleOk = async () => {
      try {
        // console.log(state.formModel);
        await state.formRef.validate();
        emit("update:loading", true);
        const { bizId } = props;
        const data = {
          tenantId: getCurrentTenantId(),
          projectId: bizId,
          ...state.formModel,
        };
        let res = await addClose(data);
        if (res.respCode !== "0000") {
          message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        emit("refresh", null);
        state.visible = false;
      } finally {
        emit("update:loading", false);
      }
    };
    const reason = ref("");
    onMountedOrActivated(async () => {
     
    });
    return {
      ...toRefs(state),
      showDialog,
      handleOk,
      //   loading,
      reason,
      cancel,
    };
  },
});
</script>
